import React from "react"

interface LoadingBannerProps {
	connectivityLoading: boolean
}

const LoadingBanner: React.FC<LoadingBannerProps> = ({connectivityLoading}) => {
	return (
		<div className="bg-blue-100 dark:bg-blue-900/30 border border-blue-400 dark:border-blue-700 text-blue-700 dark:text-blue-300 px-4 py-3 rounded mb-4">
			Loading device data...
			{connectivityLoading && <span> (Fetching connectivity...)</span>}
		</div>
	)
}

export default LoadingBanner
